<template>
	<div class="page_home_download col-lg-8 mb-8">
		<!-- title -->
		<v-chip class="font-size:3rem;" text-color="white" color="primary">常見問題</v-chip>
		<br><br>
		<slot />
	</div>
</template>

<script>
export default {
	name: 'QaLayout',
	data() {
		return {}
	}
}
</script>
